export default function EducationIcon() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="22"
      viewBox="0 0 24 22"
      fill="none"
    >
      <path
        d="M17.625 20.5V10L12 7M20.625 8.4V13.5113C20.6253 13.6731 20.573 13.8306 20.476 13.9601C19.8444 14.8005 17.18 17.875 12 17.875C6.82004 17.875 4.15558 14.8005 3.52402 13.9601C3.42699 13.8306 3.37469 13.6731 3.375 13.5113V8.4M0.75 7L12 1L23.25 7L12 13L0.75 7Z"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}
